export const defaultValues = {
  responsibleName: '',
  responsibleEmail: '',
  responsiblePhoneCode: '',
  responsiblePhone: '',

  fiscalRegime: '',
  rfc: '',
  businessName: '',
  cfdiUse: '',
};
